/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React, {useState} from "react";

import {WealthyEnv} from "helpers";

import ProductSlider from "./ProductSlider";

const ProductSliderContainer = () => {
  const [activeProduct, setActiveProduct] = useState(0);

  const productsList = [
    {
      productName: "Stocks",
      productImage: `${WealthyEnv.BROKING_CDN_URL}/product-stocks.png`,
      productTagline: "Your investing Super app",
      productAbout: "Open a free demat account with Wealthy and start investing in stocks. Wealthy has the minimal brokerage charges in the industry. There will be no account maintenance charges imposed for the first year."
    },
    {
      productName: "ETFs",
      productImage: `${WealthyEnv.BROKING_CDN_URL}/product-etfs.png`,
      productTagline: "Buy and Sell ETFs",
      productAbout: "An ETF or Exchange Traded Fund is a pooled investment that can be traded on a stock exchange similar to regular shares and stocks. These track various asset classes.<br /><br />Invest in ETFs across Equity, Gold/Silver, International and Debt through Wealthy."
    },
    {
      productName: "Futures and Options",
      productImage: `${WealthyEnv.BROKING_CDN_URL}/product-fno.png`,
      productTagline: "Trade in FnO",
      productAbout: "Futures and options are derivative instruments that allow investors to hedge their holdings based on future price movements of the underlying assets.<br /><br />You can trade in Futures and Options through Wealthy at the  nominal  brokerage charges in the industry."
    },
    {
      productName: "IPOs",
      productImage: `${WealthyEnv.BROKING_CDN_URL}/product-ipo.png`,
      productTagline: "Invest in primary market",
      productAbout: "An IPO or Initial Public Offering is when equity shares of the company are offered to the public in the stock market for the first time. Invest in IPOs through Wealthy."
    },
    {
      productName: "Wealthy Portfolio",
      productImage: `${WealthyEnv.BROKING_CDN_URL}/product-portfolio.png`,
      productTagline: "MF baskets for you",
      productAbout: "Wealthy Portfolio is a readymade basket of mutual funds curated by industry experts at Wealthy. These baskets are of various types like Tax-saving, Diversified Portfolio, Smart Switcher and much more. Invest in these baskets based on your financial goals."
    },
    {
      productName: "Mutual Funds",
      productImage: `${WealthyEnv.BROKING_CDN_URL}/product-mf.png`,
      productTagline: "Build long term wealth",
      productAbout: "You can invest in mutual fund schemes from 30+ asset management companies with Wealthy. You can get tailor-made baskets of mutual funds through the Wealthy App to build your long term wealth."
    },
    {
      productName: "SGBs",
      productImage: `${WealthyEnv.BROKING_CDN_URL}/product-sgb.png`,
      productTagline: "Sovereign Gold Bonds",
      productAbout: "SGB or Sovereign Gold Bonds are issued by RBI on behalf of the government. These help you hedge against inflation while generating returns. You can invest in these sovereign gold bonds through Wealthy in a hassle-free manner."
    },
    {
      productName: "Debentures",
      productImage: `${WealthyEnv.BROKING_CDN_URL}/product-debentures.png`,
      productTagline: "Fixed-income securities",
      productAbout: "Investors looking for fixed-income instruments can invest in bonds and debentures through the Wealthy app. There are bonds and debentures from many companies available on the Wealthy App based on your investment horizon and risk appetite."
    },
    {
      productName: "Fixed Deposits",
      productImage: `${WealthyEnv.BROKING_CDN_URL}/product-fixed-deposit.png`,
      productTagline: "Corporate FD",
      productAbout: "Wealthy offers corporate fixed deposits of high quality from select companies. You can choose these fixed deposits based on your risk tolerance and investment horizon."
    }
  ];

  // const autoSlide = () => {
  //   const nextProduct = activeProduct + 1;
  //   if (nextProduct !== productsList.length) {
  //     setActiveProduct(nextProduct);
  //   } else {
  //     setActiveProduct(0);
  //   }
  // };

  // setInterval(autoSlide, 2000);

  return (
    <ProductSlider
      activeProduct={activeProduct}
      productsList={productsList}
      setActiveProduct={setActiveProduct}
    />
  );
};

export default ProductSliderContainer;
